import { readReference } from "./raidAuthoring";

export function messageKinds(actions: any[]) {
  const messages = actions.filter((a) => a.action_type === "SHOW_MESSAGE");
  return {
    warning: messages.some((a) => a.action_params?.type === "WARNING"),
    dialogue: messages.some((a) => a.action_params?.type === "DIALOGUE"),
  };
}

export function effectReferences(actions: any[], conditions: any[]) {
  return new Set<string>(
    [
      ...actions.map((a) => readReference(a.action_params, "effect")),
      ...conditions.flatMap((c) => [
        c.effect_code,
        readReference(c.value_params, "effect"),
      ]),
    ].filter((key): key is string => typeof key === "string" && key.length > 0),
  );
}

export function seconds(value: number | null | undefined, zero = "즉시") {
  if (value == null) return "미설정";
  if (value < 0) return "무제한";
  return value === 0 ? zero : `${value}초`;
}
